import React, { useState } from 'react';

const ProductImage = ({
  src,
  alt,
  name,
  color = '#2563eb',
  className = '',
  loading = 'lazy',
  draggable,
}) => {
  const [failed, setFailed] = useState(false);
  const label = name || alt || 'AlphaPro Genetics';
  const resolvedSrc = src && src.includes('/wp-content/uploads/')
    ? `${src}${src.includes('?') ? '&' : '?'}v=20260725`
    : src;

  if (failed || !resolvedSrc) {
    return (
      <div
        className={`flex items-center justify-center rounded-2xl border border-blue-100 bg-gradient-to-br from-blue-50 via-white to-sky-100 p-4 text-center ${className}`}
        style={{
          backgroundImage: `radial-gradient(circle at 30% 20%, ${color}26 0%, transparent 55%)`,
        }}
        role="img"
        aria-label={label}
      >
        <span className="max-w-[85%] rounded-2xl bg-white/80 px-4 py-3 text-sm font-bold uppercase tracking-wide text-blue-700 shadow-sm ring-1 ring-blue-100">
          {label}
        </span>
      </div>
    );
  }

  return (
    <img
      src={resolvedSrc}
      alt={alt || label}
      loading={loading}
      draggable={draggable}
      className={className}
      onError={() => setFailed(true)}
    />
  );
};

export default ProductImage;
